import { useState } from 'react';
import apiService from '../services/api';

export const useDiseasesCrud = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createDisease = async (diseaseData) => {
    try {
      setLoading(true);
      setError(null);
      const result = await apiService.createDisease(diseaseData);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const updateDisease = async (id, diseaseData) => {
    try {
      setLoading(true);
      setError(null);
      const result = await apiService.updateDisease(id, diseaseData);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deleteDisease = async (id) => {
    try {
      setLoading(true);
      setError(null);
      const result = await apiService.deleteDisease(id);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    createDisease,
    updateDisease,
    deleteDisease,
    loading,
    error
  };
};

